/**
 *  转义字符串，防止传至后台时空格和换行被吃掉
 * @param str 待转义的字符串
 **/
const encodeString = (str = '') => {
	return (str || '').replace(/\n/g, '{line_feed}').replace(/\s/g, '{blank_space}');
};

export default encodeString;
